<template>
  <v-row justify="center">
    <v-dialog v-model="open" scrollable max-width="500px">
      <v-card>
        <v-card-title>Update Assigned To</v-card-title>
        <v-divider></v-divider>
        <div class="current-status pt-4 px-6"
          v-if="employee && employee.last_chat_assignedTo_display_name"
        >
          <span class="status-sub font-weight-medium">Currently assigned to:&nbsp;</span>
          <span class="status-text">
            {{employee.last_chat_assignedTo_display_name}}
          </span>
        </div>
        <div class="current-status pt-4 px-6"
          v-if="employee && employee.assignedTo_display_name"
        >
          <span class="status-sub font-weight-medium">Currently assigned to:&nbsp;</span>
          <span class="status-text">
            {{employee.assignedTo_display_name}}
          </span>
        </div>
        <div class="pa-4">
          <v-text-field
            placeholder="Search users"
            outlined
            hide-details
            @keydown="searchAssignedTo()"
            v-model="searchAssignedToUser"
            dense
            prepend-inner-icon="las la-search"
          ></v-text-field>
        </div>
        <!-- <v-divider></v-divider> -->
        <v-card-text style="height: 300px;" class="pa-0">
          <v-list v-if="filteredUser && filteredUser.length > 0">
            <v-list-item-group
              v-model="selected"
              active-class="primary white--text"
            >
              <template v-for="(item, index) in filteredUser">
                <v-list-item :key="item.id">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider
                  v-if="index + 1 < assignedToList.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
          <div
            v-if="filteredUser && filteredUser.length === 0"
            class="pa-4 d-flex align-center text-center"
          >
            No user found
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-end">
          <v-btn text @click="open = false">Cancel</v-btn>
          <v-btn color="primary" @click="assignEmployee">Assign</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  name: 'AssignedTo',

  props: {
    assignedToList: {
      required: true,
      type: Array
    },
    type: {
      required: false,
      type: String,
      default: 'employees'
    }
  },

  data () {
    return {
      open: false,
      selected: '',
      searchAssignedToUser: '',
      filteredUser: [],
      employee: null
    };
  },

  watch: {
    open () {
      // reset the instance
      this.selected = '';
      this.searchAssignedTo();
    }
  },

  methods: {
    searchAssignedTo () {
      const filter = this.assignedToList;
      // eslint-disable-next-line max-len
      const tempData = filter.filter(r => r.text.toLowerCase().indexOf(this.searchAssignedToUser.toLowerCase()) >= 0);
      this.filteredUser = tempData;
    },
    assignEmployee () {
      const data = {};
      if (this.type === 'employeesToMeet') {
        data.last_chat_id = this.employee && this.employee.id ? this.employee.id : '';
      }
      if (this.type === 'employees') {
        data.last_chat_id = this.employee && this.employee.last_chat_id ? this.employee.last_chat_id : '';
      }
      data.id = this.assignedToList[this.selected].id;
      this.$emit('assignEmployee', data);
      this.$nextTick(() => {
        this.open = false;
      });
    }
  }
};
</script>
